import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagSelfTestInterest = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5.6,
			y: 2.2665,
			width: 7.96667,
			height: 15.4667,
			rx: 3.4,
			stroke: "current",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.1,
			y: 4.8334,
			width: 2.96667,
			height: 4.63333,
			rx: 1.4,
			stroke: "current",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.51602,
			y: 11.8744,
			width: 2.13333,
			height: 3.28718,
			rx: 1.06667,
			stroke: "current",
			strokeWidth: 1.2
		})
	]
});
export default SvgFlagSelfTestInterest;
